import Config from '../../config.json'

const demo = Config.DEMO;
const base64Key = demo ? process.env.REACT_APP_AES_KEY : process.env.REACT_APP_AES_KEY_PROD;
export async function encryptPayload(payload) {
// const base64Key = "yollzc6ikzYpcyJMrUQdjcXpIj245KeWQb1D3kKXudg=";
 
  const keyBytes = Uint8Array.from(
    atob(base64Key),
    char => char.charCodeAt(0)
  );
 
  if (keyBytes.length !== 32) {
    throw new Error(
      `AES-256 key must be exactly 32 bytes, got ${keyBytes.length}`
    );
  }
 
  const key = await crypto.subtle.importKey(
    "raw",
    keyBytes,
    { name: "AES-GCM" },
    false,
    ["encrypt"]
  );
 
  const nonce = crypto.getRandomValues(
    new Uint8Array(12)
  );
 
  const plaintext = new TextEncoder().encode(
    JSON.stringify(payload)
  );
 
  const encryptedBuffer = await crypto.subtle.encrypt(
    {
      name: "AES-GCM",
      iv: nonce,
      tagLength: 128
    },
    key,
    plaintext
  );
 
  const encryptedBytes = new Uint8Array(
    encryptedBuffer
  );
 
  const ciphertext = encryptedBytes.slice(
    0,
    encryptedBytes.length - 16
  );
 
  const tag = encryptedBytes.slice(
    encryptedBytes.length - 16
  );
 
  const toBase64 = bytes => {
    let binary = "";
 
    for (let i = 0; i < bytes.length; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
 
    return btoa(binary);
  };
 
  return {
    encrypted: true,
    algorithm: "AES-256-GCM",
    nonce: toBase64(nonce),
    tag: toBase64(tag),
    data: toBase64(ciphertext)
  };
}
export async function decryptPayload(payload) {
 
  const keyBytes = Uint8Array.from(atob(base64Key),(char) => char.charCodeAt(0));
 
  if (keyBytes.length !== 32) {
    throw new Error(`AES-256 key must be exactly 32 bytes, got ${keyBytes.length}`);
  }
 
  const key = await crypto.subtle.importKey("raw",keyBytes,{ name: "AES-GCM" },false,["decrypt"]);
  const nonce = Uint8Array.from(atob(payload.nonce),(char) => char.charCodeAt(0));
  const tag = Uint8Array.from(atob(payload.tag),(char) => char.charCodeAt(0));
  const ciphertext = Uint8Array.from(atob(payload.data),(char) => char.charCodeAt(0));
  if (nonce.length !== 12) {
    throw new Error(`Invalid nonce length: ${nonce.length} bytes`);
  }
 
  if (tag.length !== 16) {
    throw new Error(`Invalid tag length: ${tag.length} bytes`);
  }
 
  const encryptedData = new Uint8Array(ciphertext.length + tag.length);
  encryptedData.set(ciphertext);
  encryptedData.set(tag, ciphertext.length);
 
  const decryptedBuffer = await crypto.subtle.decrypt(
    {
      name: "AES-GCM",
      iv: nonce,
      tagLength: 128
    },
    key,
    encryptedData
  );
 
  const decryptedText = new TextDecoder().decode(
    decryptedBuffer
  );
 
  return JSON.parse(decryptedText);
}
export async function encryptGetUrl(url) {
 
  const urlObj = new URL(url);
 
  // Get all query parameters
  const params = {};
 
  urlObj.searchParams.forEach((value, key) => {
    params[key] = value;
  });
 
  // Encrypt query parameters using existing AES function
  const encrypted = await encryptPayload(params);
 
  // Convert encrypted object to Base64
  const encodedData = btoa(
    JSON.stringify(encrypted)
  );
 
  // URL encode
  const safeData = encodeURIComponent(encodedData);
 
  // Remove original query parameters
  urlObj.search = `?data=${safeData}`;
 
  return urlObj.toString();
}